import styled from '@emotion/styled';
import React from 'react';
import { FC } from 'react';
import { colors } from '../../Shared/Style/colors';
import Icon from '../move-layer-down-outline-16.svg';

const ThemedDownload = styled(Icon)(() => {
    return {
        height: '24px',
        width: '24px',
        '& g': {
            stroke: colors.icons,
        },
        '& path': {
            strokeWidth: '1px',
        },
    };
});
const Download: FC = ({ ...rest }) => {
    return <ThemedDownload {...rest} />;
};

export default Download;
